import Vue from 'vue'
import Router from 'vue-router'
import routes from '@/router/routes'
import store from '@/store'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  routes,
  base: process.env.BASE_URL
})

// Verify access with options send back from the SAAS "userOptions"
function verifyAccess(to, next, route, habilitation) {
  if (to.path === route) {
    store.dispatch('getUserOptions', store.state.user.preferred_username).then(() => {
      const userOptions = store.state.userOptions
      const userAccess = userOptions && userOptions.find((el) => el.name === habilitation)

      if (userAccess.value) {
        next()
      } else {
        next('/')
      }
    })
  }
}

export const routerWithKeycloak = (keycloak) => {
  router.beforeEach((to, from, next) => {
    const isLoginPage = to.name === 'Login'

    if (!to.meta.requiresAuth) {
      if (keycloak.authenticated && isLoginPage) next('/shootings')
      next()
    } else {
      if (!keycloak.authenticated) {
        next('/login')
      } else {
        verifyAccess(to, next, '/videos/live/rooms', 'useVideoLive')
        verifyAccess(to, next, '/adminvideos', 'useAdminVideo')
        if (isLoginPage) {
          next('/shootings')
        } else next()
      }
    }
  })

  return router
}
